// src/app/core/services/delegation-token.service.ts
import { Injectable } from '@angular/core';
import { DelegationState } from '@shared/model/delegation.model';
import { BehaviorSubject, Observable } from 'rxjs';

const DELEGATION_KEY = 'delegationState';

@Injectable({
  providedIn: 'root',
})
export class AuthDelegationService {
  private isDelegating$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.initializeFromStorage();
  }

  private initializeFromStorage() {
    this.isDelegating$.next(!!this.getDelegationState());
  }

  setDelegationState(delegationState: DelegationState) {
    if (delegationState?.delegationId) {
      localStorage.setItem(DELEGATION_KEY, JSON.stringify(delegationState));
      this.isDelegating$.next(true);
    }
  }

  getDelegationState(): DelegationState | undefined {
    let delegationStateStr = localStorage.getItem(DELEGATION_KEY);
    let delegationState = undefined;
    if (delegationStateStr) {
      try {
        delegationState = JSON.parse(delegationStateStr);
        const now = new Date();
        const expiresAt = new Date(delegationState.expiresAt);
        if (expiresAt < now) {
          this.clearDelegationState();
          return undefined;
        }
      } catch (error) {
        console.error('Error parsing delegation state:', error);
        this.clearDelegationState();
        return undefined;
      }
    }
    return delegationState;
  }

  isDelegating(): Observable<boolean> {
    return this.isDelegating$.asObservable();
  }

  isDelegatingSync(): boolean {
    return !!this.getDelegationState();
  }

  clearDelegationState() {
    localStorage.removeItem(DELEGATION_KEY);
    this.isDelegating$.next(false);
  }
}
